import React, { forwardRef } from 'react';
const cx = (...classes: (string | undefined | null | false)[]) => classes.filter(Boolean).join(' ');
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  asChild?: boolean;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center font-heading tracking-widest uppercase transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-tx-whiskey focus:ring-offset-2 focus:ring-offset-tx-midnight disabled:opacity-50 disabled:cursor-not-allowed font-bold';
  const variants = {
    primary: 'bg-tx-blue text-white hover:bg-blue-600 border border-transparent',
    secondary: 'bg-tx-saddle text-tx-parchmentLight hover:bg-tx-whiskey border border-transparent',
    outline: 'bg-transparent text-tx-parchmentLight border-2 border-tx-parchmentLight hover:bg-tx-parchmentLight hover:text-tx-midnight'
  };
  const sizes = {
    sm: 'px-4 py-2 text-lg',
    md: 'px-6 py-3 text-xl',
    lg: 'px-8 py-4 text-2xl'
  };
  return <button ref={ref} className={cx(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-178" />;
});
Button.displayName = 'Button';